// extracted by mini-css-extract-plugin
module.exports = {"entity":"Entity_entity__1nalO","gridContainer":"Entity_gridContainer__3WTgb","icon":"Entity_icon__21i9F","content":"Entity_content__1BsFg","value":"Entity_value__2JwsX"};